/**
 * @generated SignedSource<<8afdce3996dfa2aa76d3d01cad80e946>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type OfferForm_partner$data = {
  readonly company: {
    readonly id: string;
  } | null;
  readonly id: string;
  readonly " $fragmentSpreads": FragmentRefs<"OfferFormHeader_partner">;
  readonly " $fragmentType": "OfferForm_partner";
};
export type OfferForm_partner$key = {
  readonly " $data"?: OfferForm_partner$data;
  readonly " $fragmentSpreads": FragmentRefs<"OfferForm_partner">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "OfferForm_partner",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "CompanyNode",
      "kind": "LinkedField",
      "name": "company",
      "plural": false,
      "selections": [
        (v0/*: any*/)
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "OfferFormHeader_partner"
    }
  ],
  "type": "PartnerNode",
  "abstractKey": null
};
})();

(node as any).hash = "96a06414eea9063fd50e4368c89cd066";

export default node;
